import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import ColumnChooser from '../../../../../components/ColumnChooser';
import ExcelExportMenu from '../../../../../components/ExcelExportMenu';
import TableConstantActions from '../../../../../components/TableConstantActions';
import { ExcelExportMode } from '../../../../../helpers/excelExportRequest';
import { rozetSayisi } from '../../../../../helpers/yakitAktarim';
import { ColumnChooserModel } from '../../../../../models/common/ColumnChooserModel';
import { RootState } from '../../../../../redux/store';
import { YakitListIstegi } from '../../../../../services/YakitService';
import { MenuComponent } from '../../../../../_metronic/assets/ts/components';

interface Props {
    columns: ColumnChooserModel[]
    setColumns: React.Dispatch<React.SetStateAction<ColumnChooserModel[]>>
    getColumns: () => ColumnChooserModel[]
    pageName: string
    pageVersion: string
    excelExport: (mode: ExcelExportMode) => void
    filter: YakitListIstegi
    setFilter: React.Dispatch<React.SetStateAction<YakitListIstegi>>
    selectedCount: number
    deleteFunction: () => void
    updateFunction: () => void
    onSearchSubmit: (e: any) => void
    iceAktar: () => void
    /** Petrol Ofisi entegrasyonu tanımlıysa "Petrol Ofisi'nden çek" düğmesi çıkar (#547). */
    petrolOfisiTanimli: boolean
    petrolOfisiCek: () => void
    /** Bekleyen aktarım hatası sayısı; > 0 ise düğmede kırmızı rozet. */
    bekleyenHata: number
}

/**
 * Yakıt kayıtları araç çubuğu: güncelle / sil, kolon seçici, Excel, Aktarım Hataları (bekleyen sayısı rozetli; entegrasyon
 * olmasa da Excel hataları için görünür), Petrol Ofisi'nden çek (entegrasyon tanımlıysa), içe aktar (örnek Excel pencerede), yeni kayıt.
 */
const YakitListFilters = ({ columns, setColumns, getColumns, pageName, pageVersion, excelExport, filter, setFilter, selectedCount, deleteFunction, updateFunction, onSearchSubmit, iceAktar, petrolOfisiTanimli, petrolOfisiCek, bekleyenHata }: Props) => {
    const navigate = useNavigate();
    const auth = useSelector((state: RootState) => state.auth)
    const ekleyebilir = !!auth.user.user?.data.authorizedMenus.find(x => x.menuName == pageName)?.canInsert;

    useEffect(() => {
        setTimeout(() => { MenuComponent.reinitialization() }, 1000)
    }, [])

    return (
        <React.Fragment>
            <TableConstantActions
                hideSearch
                deleteFunction={deleteFunction}
                onSearchSubmit={onSearchSubmit}
                pageName={pageName}
                searchTerm={filter.searchTerm}
                selectedCount={selectedCount}
                setSearchTerm={(e) => setFilter({ ...filter, searchTerm: e })}
                updateFunction={updateFunction}
            />

            <ColumnChooser columns={columns} getColumns={getColumns} pageName={pageName} pageVersion={pageVersion} setColumns={setColumns} />

            <ExcelExportMenu pageName={pageName} selectedCount={selectedCount} onExport={excelExport} />

            <button id='yakit-aktarim-hatalari' onClick={() => navigate('/yakit/hatalar')} className='btn btn-sm btn-flex btn-light-warning position-relative'>
                <i className='fa fa-triangle-exclamation fs-6 me-1' />
                Aktarım Hataları
                {
                    bekleyenHata > 0 && (
                        <span className='position-absolute top-0 start-100 translate-middle badge badge-circle badge-danger' title={`${bekleyenHata} bekleyen aktarım hatası`}>
                            {rozetSayisi(bekleyenHata)}
                        </span>
                    )
                }
            </button>

            {
                petrolOfisiTanimli && ekleyebilir && (
                    <button id='yakit-petrol-ofisi-cek' onClick={petrolOfisiCek} className='btn btn-sm btn-flex btn-light-success'>
                        <i className='fa fa-cloud-arrow-down fs-6 me-1' />
                        Petrol Ofisi'nden çek
                    </button>
                )
            }

            {
                ekleyebilir && (
                    <button onClick={iceAktar} className='btn btn-sm btn-flex btn-light-success'>
                        <i className='fa fa-file-import fs-6 me-1' />
                        Excel'den içe aktar
                    </button>
                )
            }

            {
                ekleyebilir && (
                    <div className='m-0'>
                        <a onClick={() => navigate('/yakit/listadd')} className='btn btn-sm fw-bold btn-primary'>Yeni Kayıt Ekle</a>
                    </div>
                )
            }
        </React.Fragment>
    )
}

export default YakitListFilters;
